var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-layout-default-header',{on:{"open-navigation":_vm.openNavigation}}),_c('app-layout-default-sidebar',{ref:"sidebar"}),_c('v-main',[_c('app')],1),_c('app-layout-default-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }